import { put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from 'redux-starter-kit';
import { Requests } from '@erecruit/types';
import { getResourceApi } from '@erecruit/modules';
import { ShiftRecordResponse, ShiftRecordSections } from '../types';
import { fetchShiftRecordSuccess, fetchShiftRecordFail } from './reducer';

const getSections = (response: ShiftRecordResponse): ShiftRecordSections => {
  const [shiftGeneral, shiftBonus, shiftSchedule] = response;

  return {
    general: shiftGeneral.data[0],
    schedule: shiftSchedule.data[0],
    bonus: shiftBonus.data[0],
  };
};

function* processFetchShiftRecord({ payload: id }: PayloadAction<number>) {
  try {
    const filter = {
      ids: [id],
    };
    const data: ShiftRecordResponse = yield getResourceApi().getResources([
      new Requests.ShiftRequest({ filter }),
      new Requests.ShiftBonusRequest({ filter }),
      new Requests.ShiftScheduleRequest({ filter }),
    ]);

    const sections = getSections(data);

    yield put(
      fetchShiftRecordSuccess({
        sections,
      }),
    );
  } catch (e) {
    yield put(fetchShiftRecordFail(e.message));
  }
}

function* watchForFetchShiftRecord() {
  yield takeLatest('shiftRecord/fetchShiftRecord', processFetchShiftRecord);
}

export default [watchForFetchShiftRecord()];
